/**
 * @param state {object} Domain state
 * @param toastMessage {object} Toast message
 * @return {object} Updated domain state
 */
export const saveToastMessageReducer = (state, toastMessage) => {

    state.toastMessages.push(toastMessage);

    return state;
};
